// Orchard: add a cart icon (with live item count) to the top nav on every page,
// linking straight to /cart. Additive and safe — remove the
// <script src='oe-cart-nav.js'> include in layout/orchard.liquid to revert.
(function () {
  var SVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"></circle><circle cx="18" cy="20" r="1.4"></circle><path d="M2 3h2.2l2.3 12.2a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.27L21.5 7H6"></path></svg>';
  function refresh(a) {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var n = (c && c.item_count) || 0;
          var b = a.querySelector('.oe-cart-count');
          if (!b) return;
          if (n > 0) { b.textContent = n; b.style.display = 'block'; } else { b.style.display = 'none'; }
        }).catch(function () {});
    } catch (e) {}
  }
  function build(links) {
    if (!links || links.querySelector('.oe-cart-link')) return;
    var a = document.createElement('a');
    a.className = 'oe-cart-link';
    a.href = '/cart';
    a.setAttribute('aria-label', 'Cart');
    a.style.cssText = 'position:relative;display:inline-flex;align-items:center;margin-left:6px;';
    a.innerHTML = SVG + '<span class="oe-cart-count" style="display:none;position:absolute;top:-7px;right:-9px;min-width:16px;height:16px;padding:0 4px;border-radius:999px;background:#c3d600;color:#0a3a1f;font-family:&#39;Space Mono&#39;,monospace;font-size:10px;font-weight:700;line-height:16px;text-align:center;box-sizing:border-box;"></span>';
    links.appendChild(a);
    refresh(a);
  }
  function scan() {
    var ls = document.querySelectorAll('.nav .links');
    for (var i = 0; i < ls.length; i++) build(ls[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
